<template>
  <v-dialog v-model="dialog.show" max-width="600" persistent>
    <v-card>
      <v-toolbar :color="getAppBarColor" dark>{{ dialog.title }}</v-toolbar>
      <v-card-text>
        <v-form ref="form">
          <v-row align="center">
            <v-col cols="4" v-show="!dialog.edit">
              <v-text-field
                v-model="prazoId"
                :rules="[rules.required, rules.isNumber]"
                label="Prazo"
                prefix="x"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="prazo.contemplacao"
                :rules="[rules.required, rules.isNumber]"
                label="Contemplação"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="prazo.fundoReserva"
                :rules="[rules.required, rules.isNumber]"
                label="Fundo Reserva"
                suffix="%"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="prazo.participantes"
                :rules="[rules.required, rules.isNumber]"
                label="Participantes"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="prazo.seguroVida"
                :rules="[rules.required, rules.isNumber]"
                label="Seguro de Vida"
                suffix="%"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="prazo.taxaAdm"
                :rules="[rules.required, rules.isNumber]"
                label="Taxa ADM"
                suffix="%"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="prazo.vencimento"
                :rules="[rules.required, rules.isNumber]"
                label="Vencimento"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="blue darken-1"
          small
          dark
          rounded
          depressed
          @click="dialog.edit ? editItem() : save()"
          >Salvar</v-btn
        >

        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="red darken-2"
          small
          dark
          rounded
          depressed
          @click="close()"
          >Fechar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import rules from "@/utils/rules";
import Prazo from "@/services/prazo";

export default {
  name: "DialogFormPrazo",

  data() {
    return {
      dialog: {
        show: false,
        title: "",
        edit: false
      },
      prazo: {
        contemplacao: "",
        fundoReserva: "",
        participantes: "",
        seguroVida: "",
        taxaAdm: "",
        vencimento: "",
        ativo: true
      },
      prazoId: "",
      consorcio: null,
      rules,
      servicePrazo: new Prazo()
    };
  },

  methods: {
    show(edit, prazo, consorcio) {
      this.consorcio = consorcio;
      if (edit) {
        this.prazoId = prazo.id;
        this.prazo.contemplacao = prazo.contemplacao;
        this.prazo.fundoReserva = prazo.fundoReserva;
        this.prazo.participantes = prazo.participantes;
        this.prazo.seguroVida = prazo.seguroVida;
        this.prazo.taxaAdm = prazo.taxaAdm;
        this.prazo.vencimento = prazo.vencimento;
        this.prazo.ativo = prazo.ativo;
        this.dialog.edit = true;
        this.dialog.title = `Editar Prazo ${prazo.id}`;
      } else {
        this.dialog.edit = false;
        this.dialog.title = "Novo Prazo";
      }
      this.dialog.show = true;
    },

    async save() {
      if (this.$refs.form.validate()) {
        this.convertValuesToFloat();
        try {
          const response = await this.servicePrazo.createPrazoConsorcio(
            this.consorcio,
            { ...this.prazo },
            this.prazoId
          );
          this.$emit("created", response);
          this.close();
          return Promise.resolve();
        } catch (error) {
          this.$toast.error("Erro ao cadastrar Prazo");
          return Promise.reject(error);
        }
      }
    },

    async editItem() {
      if (this.$refs.form.validate()) {
        this.convertValuesToFloat();
        try {
          const response = await this.servicePrazo.updatePrazoConsorcio(
            this.consorcio,
            { ...this.prazo },
            this.prazoId
          );
          this.$emit("updated", response);
          this.close();
          return Promise.resolve();
        } catch (error) {
          this.$toast.error("Erro ao atualizar Prazo");
          return Promise.reject(error);
        }
      }
    },

    close() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.dialog.show = false;
    },

    convertValuesToFloat() {
      this.prazo.contemplacao = parseFloat(this.prazo.contemplacao);
      this.prazo.fundoReserva = parseFloat(this.prazo.fundoReserva);
      this.prazo.participantes = parseFloat(this.prazo.participantes);
      this.prazo.seguroVida = parseFloat(this.prazo.seguroVida);
      this.prazo.taxaAdm = parseFloat(this.prazo.taxaAdm);
      this.prazo.vencimento = parseFloat(this.prazo.vencimento);
    }
  }
};
</script>
